import Resizer from "react-image-file-resizer";
import { RESIZED_IMG_QUALITY } from "./constants";

export const resizeImage = (
  file: File,
  maxWidth: number,
  maxHeight: number,
  format: string,
  callback: (resizedFile: File | string | Blob | ProgressEvent<FileReader>) => void
) => {
  const outputFormat = format === "image/png" ? "PNG" : "JPEG";

  Resizer.imageFileResizer(
    file,
    maxWidth,
    maxHeight,
    outputFormat,
    RESIZED_IMG_QUALITY,
    0,
    (resizedFile) => {
      callback(resizedFile);
    },
    "file"
  );
};
